import { useEffect, useRef } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { parseXimiProvisioningFromDeeplink } from './parseXimiProvisioning';
import { useXimiSSOAuth } from './useXimiSSOAuth';

/**
 * Native-only: transforme un deeplink de provisioning Ximi en login SSO.
 * Quand Ximi web intégrera Stimul'In et affectera le bon custom scheme au QR,
 * l'OS ouvrira l'app avec cette URL (appUrlOpen). On la parse (même parser que le
 * scan QR), puis on déclenche le SSO — sans scan manuel. Le compte est persisté
 * APRÈS auth réussie (usePersistXimiAccount), pas ici. No-op sur le web.
 */
export function useXimiDeeplink(): void {
    const ximiSSO = useXimiSSOAuth();
    // login est recréé à chaque render → ref pour ne s'abonner qu'une fois.
    const loginRef = useRef(ximiSSO.login);
    loginRef.current = ximiSSO.login;

    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return undefined;

        const handlePromise = App.addListener(
            'appUrlOpen',
            async ({ url }: URLOpenListenerEvent) => {
                const provisioning = parseXimiProvisioningFromDeeplink(url);
                if (!provisioning) return; // pas un lien Ximi → on ignore
                const { tenantCode, loginHint } = provisioning;
                await loginRef.current({ tenantCode, loginHint });
            }
        );

        return () => {
            handlePromise.then((handle) => handle.remove());
        };
    }, []);
}
